import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Radio Button
 *
 * @param props - checked, onChange, value, name, ariaLabel, disabled
 * @example
 * <Radio
 * 	id=''
 * 	onChange={() => {}}
 * 	value={"Radio"}
 * 	name={"Radio"}
 * 	ariaLabel={"Radio button"}
 * 	disabled={true || false}
 * />
 * @returns React.ReactElement
 */
var Radio = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Radio.defaultProps = {
    disabled: false,
    value: "",
    ariaLabel: "Radio button",
};
var SampleProps = {
    id: '',
    onChange: function () { },
    name: "Radio",
    ariaLabel: "Radio button",
    disabled: false,
};
export default Radio;
export { SampleProps as RadioSample, };
